import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Product } from '../types/product.type';
import { ADMIN_PRODUCTS_API_PATHS } from '../constants/products-api-paths.constants';

type UseArchiveProductResult = {
  archiveProduct: (productId: string) => Promise<Product | null>;
  isSubmitting: boolean;
};

export function useArchiveProduct(): UseArchiveProductResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveProduct = async (productId: string): Promise<Product | null> => {
    setIsSubmitting(true);

    try {
      const archivedProduct = await HttpClient.delete<Product>(ADMIN_PRODUCTS_API_PATHS.ARCHIVE_PRODUCT(productId));

      enqueueSnackbar('Produit archivé', { variant: 'success' });
      return archivedProduct;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage du produit"),
        {
          variant: 'error',
        }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveProduct, isSubmitting };
}
